import { useNuxtApp } from "#app";

export const useBugReporter = () => {
  return useNuxtApp().$bugReporter;
};
